import { cn } from '@hero/web-lib';

export interface InputLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  label: string;
  required?: boolean;
}

export function InputLabel({ label, required, className, ...rest }: InputLabelProps) {
  return (
    <label
      className={cn('block text-sm font-medium text-gray-700 mb-2', className)}
      {...rest}>
      {label} {required && <span className="text-destructive">*</span>}
    </label>
  );
}
